import { matchPath } from 'react-router'
import { AppRoutes, RACES_ROUTES } from '@core/AppRoutes'

export const isRaceRoute = (path: string): boolean =>
  RACES_ROUTES.some(route =>
    Array.isArray(route)
      ? route.some(route => isRouteMatch(route, path))
      : isRouteMatch(route as string, path)
  )

export const isBetLoopRoute = (path: string): boolean => {
  const cleanedPath = path.includes('?') ? path.slice(0, path.indexOf('?')) : path
  return isRouteMatch(AppRoutes.BetLoop, cleanedPath)
}

// =============
// Local Helpers
// =============

function isRouteMatch(patternToMatch: string, path: string) {
  if (matchPath(patternToMatch, path)) {
    return true
  }
  if (!patternToMatch.endsWith('/')) {
    // new v7 router check for non exact paths like this
    return !!matchPath(patternToMatch + '/*', path)
  }
  return false
}
